import { defineMessages } from 'react-intl';

import { sharedMessages } from '@app/translations';

export const removeHoldToastMessages = {
  ...defineMessages({
    successHold: {
      id: 'removeHoldToast.holdSuccessfullyRemoved',
      defaultMessage: 'Hold successfully removed',
    },
    successRequest: {
      id: 'removeHoldToast.requestSuccessfullyRemoved',
      defaultMessage: 'Request successfully removed',
    },
  }),
  error: sharedMessages.somethingWentWrongPleaseTryAgain,
};
